<!--
 * @Description: lbImage
 * @Author: xiao li
 * @Date: 2021-07-04 00:16:14
 * @LastEditTime: 2023-12-01 16:22:14
 * @LastEditors: DXV-RGWU-TUFH-RFCY-IEGMYY
-->
<template>
  <!-- 编辑图片 -->
  <el-dialog
    title="编辑图片"
    :visible.sync="show"
    width="1150px"
    top="5vh"
    center
    :before-close="close"
  >
    <div class="c-title text-bold">
      {{ info.title }}
    </div>
    <div class="flex-warp editimg-list mt-sm mb-lg">
      <div
        @click="selectImg(index)"
        class="item-img mt-md mr-md rel"
        :style="{ borderColor: index === info.index ? '#409EFF' : '#999' }"
        v-for="(item, index) in info.list"
        :key="index"
      >
        <img class="cover" :src="item.old_url" />
        <div class="cover flex-center abs" v-if="/\.(gif)$/.test(item.old_url)">
          <div class="flex-center c-base radius">不可编辑</div>
        </div>
      </div>
    </div>
    <div v-if="info.can_crop && crap">
      <div class="f-caption c-warning mb-md">
        将鼠标放至下方区域，滚动鼠标可放大缩小图片
      </div>
      <div class="mb-lg">
        <el-button size="mini" type="danger" plain @click="rotateLeft"
          >↺ 左旋转</el-button
        >
        <el-button size="mini" type="danger" plain @click="rotateRight"
          >↻ 右旋转</el-button
        >
        <el-button size="mini" type="danger" plain @click="refreshCrop"
          >刷新图片</el-button
        >
      </div>
    </div>
    <div class="flex-warp">
      <div v-if="info.can_crop && crap">
        <div>
          <div
            class="cropper"
            :style="{
              width: `${imgObj.width}px`,
              height: `${imgObj.height}px`
            }"
          >
            <vue-cropper
              ref="cropper"
              :img="option.img"
              :outputSize="option.outputSize"
              :outputType="option.outputType"
              :info="option.info"
              :canScale="option.canScale"
              :autoCrop="option.autoCrop"
              :autoCropWidth="option.autoCropWidth"
              :autoCropHeight="option.autoCropHeight"
              :fixed="option.fixed"
              :fixedNumber="option.fixedNumber"
              :full="option.full"
              :fixedBox="option.fixedBox"
              :canMove="option.canMove"
              :canMoveBox="option.canMoveBox"
              :original="option.original"
              :centerBox="option.centerBox"
              :height="option.height"
              :infoTrue="option.infoTrue"
              :maxImgSize="option.maxImgSize"
              :enlarge="option.enlarge"
              :mode="option.mode"
              @realTime="realTime"
              @imgLoad="imgLoad"
            >
            </vue-cropper>
          </div>
        </div>
      </div>
      <div
        style="border: 1px solid #39f"
        v-if="
          !info.can_crop || (info.can_crop && !crap && previews.w && previews.h)
        "
      >
        <div
          ref="htmltocanvas_watermark"
          class="mask-img-info rel"
          :style="{
            width: `${imgObj.width}px`,
            height: `${imgObj.height}px`
          }"
        >
          <img class="cover" :src="option.img" />
          <div class="trans-form">
            <div
              class="add-watermark abs flex-warp f-icontext c-caption text-bold"
              :style="{
                width: `${imgObj.h_num}px`,
                opacity: mark_percent / 100
              }"
            >
              <div
                class="text flex-center"
                :style="{
                  width: `${imgObj.mark_w}px`,
                  height: `${imgObj.mark_w}px`
                }"
                v-for="(item, index) in imgObj.v_num"
                :key="index"
              >
                {{ info.img_watermark }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div style="width: 300px; margin-left: 20px">
        <el-button
          type="primary"
          size="medium"
          plain
          @click="startCrop"
          v-if="info.can_crop && !crap && !previews.w && !previews.h"
          >裁剪图片</el-button
        >
        <el-button
          type="danger"
          size="medium"
          plain
          @click="resetCrop"
          v-if="info.can_crop && !crap && previews.w && previews.h"
          >重新裁剪</el-button
        >
        <el-button
          type="primary"
          size="medium"
          plain
          @click="addMark(1)"
          v-if="crap && previews.w && previews.h"
          >添加水印</el-button
        >
        <el-button
          type="success"
          size="medium"
          plain
          @click="addMark('htmltocanvas_watermark')"
          v-if="
            !info.can_crop ||
            (info.can_crop && !crap && previews.w && previews.h)
          "
          >保存图片</el-button
        >
        <block
          v-if="
            !info.can_crop ||
            (info.can_crop && !crap && previews.w && previews.h)
          "
        >
          <div class="mt-lg c-title text-bold">水印透明度</div>
          <div class="f-caption c-warning mb-md">
            切换水印透明度后，需点击「保存图片」按钮
          </div>
          <div class="flex-between" style="width: 100%">
            <div style="width: 245px">
              <lb-slider
                :min="0"
                :max="100"
                :value="mark_percent"
                :isDrag="true"
                bgColor="#4ab157"
                @input="changeSlider"
                @stop="changeSlider"
              ></lb-slider>
            </div>
            <div>{{ mark_percent }}%</div>
          </div>
        </block>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import html2canvas from 'html2canvas'
import VueCropper from '../basics/vueCropper/vue-cropper.vue'
export default {
  name: 'lbEditImg',
  components: {
    VueCropper
  },
  props: {
    info: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  data () {
    return {
      show: false,
      crap: false,
      devicePixel: window.devicePixelRatio,
      previews: {},
      option: {
        img: '', // 裁剪图片的地址
        info: true, // 裁剪框的大小信息(即是否显示裁剪框的宽高信息)
        outputSize: 1, // 裁剪生成图片的质量(0.1~1之间)
        outputType: 'jpeg', // 裁剪生成图片的格式(jpg(jpg 需要传入jpeg))
        canScale: true, // 图片是否允许滚轮缩放(这个属性貌似没得用，不管设置true，false都可以滚轮缩放)
        autoCrop: true, // 是否默认生成截图框
        // 注：这里需要注意，如果是裁剪成圆形图片，那么截图框的宽高就是必须设置的，且最好宽高一样
        autoCropWidth: 500, // 默认生成截图框宽度
        autoCropHeight: 500, // 默认生成截图框高度
        fixedBox: true, // 固定截图框大小 不允许改变
        fixed: true, // 是否开启截图框宽高固定比例
        fixedNumber: [1, 1], // 截图框的宽高比例(这是比例，按两个值的比值大小进行截图框的宽高的设置，[1,1]和[100,100]是一样的)
        full: false, // 是否输出原图比例的截图
        canMove: true, // 上传图片是否可以移动
        canMoveBox: false, // 截图框能否拖动
        original: false, // 上传图片按照原始比例渲染
        centerBox: false, // 截图框是否被限制在图片里面
        infoTrue: false // true 为展示真实输出图片宽高 false 展示看到的截图框宽高
      },
      imgObj: {
        width: 500,
        height: 500
      },
      mark_percent: 0,
      lockTap: false
    }
  },
  watch: {
    'option.img' (newval, oldval) {
      const that = this
      const img = new Image()
      img.src = newval
      img.onload = function () {
        let { width, height } = this
        let minW = 750
        if (width * 1 > minW) {
          let scla = (minW / width * 1).toFixed(2)
          width = minW
          height = parseInt(height * 1 * scla)
        }
        let cropW = width > height ? height : width
        let markW = that.info.img_watermark.length * 14 + 10
        let h = Math.ceil(width / markW)
        let v = Math.ceil(height / markW)
        that.imgObj = {
          width,
          height,
          h_num: h * markW,
          v_num: v * h,
          mark_w: markW
        }
        let { can_crop: canCrop } = that.info
        that.option.autoCropWidth = canCrop ? cropW : width
        that.option.autoCropHeight = canCrop ? cropW : height
        that.option.fixedNumber = !canCrop ? [width, height] : [1, 1]
      }
    }
  },
  methods: {
    changeSlider (e) {
      this.mark_percent = e
    },
    selectImg (index) {
      if (this.lockTap) {
        this.$message.warning('图片上传中，请耐心等待！')
        return
      }
      let { old_url: url, mark_percent: markPercent } = this.info.list[index]
      if (/\.(gif)$/.test(url)) {
        this.$message.error('不支持动态图片哦')
        return
      }
      this.info.index = index
      this.mark_percent = markPercent || 0
      this.option.img = url
    },
    // 初始化函数
    imgLoad () {
    },
    startCrop () {
      this.crap = true
      this.option.autoCrop = true
      this.$refs.cropper.startCrop()
    },
    resetCrop () {
      this.previews = {}
      let { index } = this.info
      this.option.img = this.info.list[index].old_url
      this.startCrop()
    },
    refreshCrop () {
      this.$refs.cropper.refresh()
    },
    // 图片缩放
    changeScale (num) {
      num = num || 1
      this.$refs.cropper.changeScale(num)
    },
    // 向左旋转
    rotateLeft () {
      this.$refs.cropper.rotateLeft()
    },
    // 向右旋转
    rotateRight () {
      this.$refs.cropper.rotateRight()
    },
    // 实时预览函数
    realTime (data) {
      this.previews = data
    },
    async addMark (refskey) {
      if (refskey === 1) {
        this.$refs.cropper.getCropData((data) => {
          this.option.img = data
          this.info.list[this.info.index].url = data
          this.crap = false
        })
        return
      }
      let that = this
      let { devicePixelRatio, mark_percent: markPercent } = that
      let { index, list, can_crop: canCrop } = that.info
      if (!canCrop && markPercent * 1 === 0) {
        that.info.list[index].url = list[index].old_url
        that.info.list[index].mark_percent = 0
        that.$message.success(`图片保存成功`)
        return
      }
      if (this.lockTap) return
      this.lockTap = true
      let canvasID = this.$refs[refskey]
      const opts = {
        tainttest: true, // 检测每张图片都已经加载完成
        useCORS: true, // 跨域处理，可以加载网络图片
        logging: true, // 日志开关
        // scale: devicePixelRatio < 3 ? devicePixelRatio : 2
        scale: devicePixelRatio
      }
      html2canvas(canvasID, opts).then(canvas => {
        const img = new Image()
        img.src = canvas.toDataURL('jpeg')
        img.setAttribute('crossOrigin', 'anonymous')
        var context = canvas.getContext('2d')
        img.onload = function () {
          let { width, height } = img
          // width = width * 2
          // height = height * 2
          canvas.width = width
          canvas.height = height
          context.drawImage(img, 0, 0, width, height)
          let url = canvas.toDataURL('image/jpeg')
          let item = list[index]
          item.mark_percent = markPercent
          that.$message.warning('图片上传中，请耐心等待！')
          try {
            that.$api.upload.base64ToPngClouds({ img: url }).then(res => {
              if (res.code === 200) {
                let { attachment_path: path } = res.data
                item.url = path
                that.info.list[index] = item
                that.$message.success(`图片上传成功`)
                that.lockTap = false
              }
            })
          } catch (e) {
            that.lockTap = false
          }
        }
      })
    },
    open () {
      let { index = 0, can_crop: canCrop } = this.info
      this.option.autoCrop = canCrop
      this.option.canScale = canCrop
      this.option.full = !canCrop
      this.crap = canCrop
      if (canCrop) {
        this.info.list.map(item => {
          item.crop_img = item.url
        })
        this.option.fixedNumber = [1, 1]
      }
      this.show = true
      this.selectImg(index)
    },
    async close () {
      if (this.lockTap) {
        this.$message.warning('图片上传中，请耐心等待！')
        return
      }
      if (this.info.can_crop) {
        this.info.list.map(item => {
          item.url = item.url.includes('data:image/jpeg;base64') ? item.crop_img || item.old_url : item.url
          item.mark_percent = item.url ? item.mark_percent : 0
        })
      }
      this.previews = {}
      this.option.img = ''
      this.option.autoCrop = false
      this.crap = false
      this.show = false
      this.$emit('change', this.info.list)
    }
  }
}
</script>

<style lang="scss" scoped>
.editimg-list {
  .item-img {
    width: 50px;
    height: 50px;
    border: 1px solid #999;
    .cover {
      width: 48px;
      height: 48px;
      object-fit: cover;
    }
    .cover.abs {
      top: 0;
      left: 0;
      background: rgba(0, 0, 0, 0.5);
      .radius {
        width: 50px;
        height: 20px;
        font-size: 10px;
        background: rgba(0, 0, 0, 0.8);
        transform: scale(0.9);
      }
    }
  }
}
.preview {
  overflow: hidden;
  border: 1px solid #67c23a;
  background: #cccccc;
}

.mask-img-info {
  overflow: hidden;
  .cover {
    width: 100%;
    height: 100%;
    display: block;
  }
}
.add-watermark {
  top: 0;
  left: 0;
  .text {
    // width: 120px;
    // height: 120px;
    transform: rotate(-45deg);
  }
  .bg-mark {
    background-repeat: no-repeat;
    background-size: 100px;
    background-position: 50% 55%;
    background-image: url(https://xiuxiupro-material-center.meitudata.com/material/image/630f1405e667c9088.png);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/basics/lbEditImg.vue